// LivestreamDetailOnlineFooterMobile.js
'use strict';
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import LivestreamDetailOnlineFooterMobile from '../component/LivestreamDetailOnlineFooterMobile.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';
import getModalData from '../selector/getModalData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import checkLivestreamChatPreflightAndOpenPanel from '../action/checkLivestreamChatPreflightAndOpenPanel.js';

import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import toggleModal from '../action/toggleModal.js';
import login from '../action/login.js';
import setPlayerData from '../action/setPlayerData.js';

import {
  PRESET_SD,
  ExclusivePrivateStatus,
} from '../resource/liveStreamConstants.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import { BLUROUT_PARAMETERS } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const isAuthed = !!getMeData(state, 'id');
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );

  const previewBlurManifest = getRemoteConfigData(
    state,
    BLUROUT_PARAMETERS
  )?.[2];
  const isStreamPreviewBlurEnabled = !!previewBlurManifest;
  const shouldDisplayBlurCountdown =
    isStreamPreviewBlurEnabled && streamStatus === PRESET_SD && !hasStreamToken;

  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );

  return {
    isAuthed,
    isStreamer: meId != null && meId === streamId,
    streamStatus,
    isChatPanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isChatPanelOpen'
    ),
    isGiftModalOpen:
      getModalData(state, 'LiveStreamGiftModal', 'status') === 'display',
    isKaraokeModalOpen:
      getModalData(state, 'LiveStreamKaraokeModal', 'status') === 'display',
    isSuperChatOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isSuperChatOpen'
    ),
    isTriggerPrivateModalOpen:
      getModalData(state, 'LiveStreamTriggerPrivateModal', 'status') ===
      'display',
    isLiveStreaming: getLiveStreamData(state, [streamId], 'isLiveStreaming'),
    streamPreviewBlurDuration: +getRemoteConfigData(
      state,
      BLUROUT_PARAMETERS
    )?.[1],
    shouldDisplayBlurCountdown,
    hasStreamToken,
    shouldUseLivestreamAlert: getOperationData(
      state,
      ['liveStream', 'chat', streamId],
      'shouldUseLivestreamAlert'
    ),
    settingHintOpenedTimestamp: getOperationData(
      state,
      ['liveStream'],
      'settingHintOpenedTimestamp'
    ),
    privateShowStatus: getPrivateShowStatus(state, streamId),
    isKaraokeDeviceOnline: !!getLiveStreamData(state, [streamId], 'device'),
    isMuted: getOperationData(state, ['player'], 'isMuted'),
    isExclusivePrivateOngoing: [
      ExclusivePrivateStatus.PERFORMING,
      ExclusivePrivateStatus.PREPARING,
    ].includes(exclusivePrivateStatus),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    setChatPanel: ({ isChatPanelOpen }) =>
      dispatch(setLiveStreamPanel({ isChatPanelOpen })),
    toggleModal: data => dispatch(toggleModal(data)),
    checkLivestreamChatPreflightAndOpenPanel: ({ streamId }) =>
      dispatch(checkLivestreamChatPreflightAndOpenPanel({ streamId })),
    setSettingHintOpenedTimestamp: ({ settingHintOpenedTimestamp }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream'],
          data: {
            settingHintOpenedTimestamp,
          },
        },
      }),
    setMuted: data => dispatch(setPlayerData(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LivestreamDetailOnlineFooterMobile)
);
